// src/app/shared/services/platform.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private apiUrl = "";

  constructor(private http: HttpClient) { }

  // Existing (local file) method
  getDashboardConfig(filePath: string): Observable<any> {
    return this.http.get(filePath);
  }

  // get dashboard from API  method
  getDashboardConfigFromApi(projectId: string, dvmWorkflowAppId: string): Observable<any> {
    const payload = {
      project_id: projectId,
      dvm_workflow_app_id: dvmWorkflowAppId
    };
    const comma = true;

    // When comma is true, skip API call completely and return empty response.
    if (comma) {
      return of([]);
    }

    return this.http.post<any>(this.apiUrl, payload);

  }
}
